import { render, staticRenderFns } from "./CentralCommittee.vue?vue&type=template&id=4cf26456&scoped=true&"
import script from "./CentralCommittee.vue?vue&type=script&lang=js&"
export * from "./CentralCommittee.vue?vue&type=script&lang=js&"
import style0 from "./CentralCommittee.vue?vue&type=style&index=0&id=4cf26456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf26456",
  null
  
)

export default component.exports